let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty("--vh", `${vh}px`);

(function ($, window, document, undefined) {
  //jquery reference
  var internalClick = false;

  var ua = window.navigator.userAgent;
  var iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
  var webkit = !!ua.match(/WebKit/i);
  var iOSSafari = iOS && webkit && !ua.match(/CriOS/i);

  function sleep(time) {
    return new Promise((resolve) => setTimeout(resolve, time));
  }

  function openEventPage(link) {
    
    var eventPageVisible = jQuery("#eventPage").css("opacity") == "1";
    var eventSlug = link.substring(link.indexOf("event/") + 6, link.length);
    
    var currentEvent = $("#eventDates .event-item." + eventSlug);

    var eventImageUrl = currentEvent.data('image');
    var eventPlaylist = currentEvent.data('playlist');
    var eventTitle = currentEvent.find(".event-title a").html();
    var eventDate = currentEvent.find(".event-date").text();
    var eventDescription = currentEvent.find(".event-description").html();
    var eventNext = jQuery(".event-next");
    var eventPrev = jQuery(".event-prev");
    var eventLinkLabel = currentEvent.find(".event-link-label").html();
    var eventLinkUrl = currentEvent.find(".event-link-url").text();

    // changing content by paginate
    if (eventPageVisible) {
      anime({
        targets: "#eventPage .event-wrapper",
        opacity: 0,
        top: 0,
        easing: "cubicBezier(0.7, 0, 0.2, 1)",
        duration: 300,
      });
    }

    setTimeout(() => {
      $("#eventPage .event-image img").attr("src", eventImageUrl);
      $("#eventPage .event-details h3").html(eventTitle);
      $("#eventPage .event-details h4").text(eventDate);
      $("#eventPage .event-details .event-description").html(eventDescription);  
      $("#eventPage .event-details #event-playlist").attr('href', eventPlaylist);
      $("#eventPage .event-details .event-remind").attr('href', eventLinkUrl);  
      $("#eventPage .event-details .event-remind").html(eventLinkLabel);

      if (eventLinkLabel == null && eventPlaylist == '') {
        $('#eventPage .event-divider').hide()
      }

      if (eventLinkLabel == null) {
        $("#eventPage .event-details .event-remind").hide()
      } else {
        $("#eventPage .event-details .event-remind").show()
      }
      
      // event playlist      
      if (eventPlaylist != '') {
        $("#modal-spotify-artist .modal-body").html("");
        setTimeout(() => {
          if (!eventPlaylist.includes(".com/embed/")) {
            eventPlaylist = eventPlaylist.substring(0, eventPlaylist.indexOf(".com") + 5) + 'embed' + eventPlaylist.substring(eventPlaylist.indexOf(".com") + 4, eventPlaylist.length);
          }
          $("#modal-spotify-artist iframe").attr("src", eventPlaylist);
          $("#eventPage .event-details #event-playlist").show();
          $("#modal-spotify-artist .modal-body").html('<iframe src="' + eventPlaylist + '" allowtransparency="true" width="100%" height="270" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>');
        }, 100);
      } else {
        $("#eventPage .event-details #event-playlist").hide();
      }
      // wait for image load to awoid flash
      if (eventPageVisible) {
        $("#eventPage .event-image img").load(function() {
          anime({
            targets: "#eventPage .event-wrapper",
            opacity: 1,
            top: 0,
            easing: "cubicBezier(0.7, 0, 0.2, 1)",
            duration: 300,
          });
        });
      }
    }, (eventPageVisible ? 300 : 0));
            
    // find next and previous events
    setTimeout(() => {
      
      var eventLinks = document.querySelectorAll('.fc-calendar-event a[href^="#event/"]');    

      eventLinks.forEach( (element, i) => {
        var eSlug = element.href.substring(element.href.indexOf("event/") + 6, element.href.length);      
        
        if (eSlug == eventSlug) {
            var 
              prevSlug = i > 0 ? eventLinks[i-1].href : '',
              nextSlug = i == (eventLinks.length-1) ? '' : eventLinks[i+1].href;  
            
            if (prevSlug != '') {
              eventPrev.removeClass('disabled');
              eventPrev.attr("href", "#" + prevSlug.substring(prevSlug.indexOf("event/"), prevSlug.length));
            } else {
              eventPrev.attr("href", "#");
              eventPrev.addClass('disabled');
            }          
            if (nextSlug != '') {
              eventNext.removeClass('disabled');
              eventNext.attr("href", "#" + nextSlug.substring(nextSlug.indexOf("event/"), nextSlug.length));
            } else {
              eventNext.attr("href", "#");
              eventNext.addClass('disabled');
            }
            return false;
          }  
      });
    }, 100);    
    

    if (!eventPageVisible) {
      anime({
        targets: "#eventPage",
        opacity: 1,
        top: 0,
        easing: "cubicBezier(0.7, 0, 0.2, 1)",
        duration: 1000,
      });
    }
  }

  function toggleMainMenu() {
    if (!$('body').hasClass('main-menu-open')) {

      $('body').addClass('main-menu-open')

      var menuRevealTimeline = anime.timeline({
        easing: "cubicBezier(0.7, 0, 0.2, 1)",
        duration: 1000,
        // duration: 1,
        complete: function () {
          $(".menu-blocks").removeClass("animate");
        },
      });

      // $('.menu-blocks-wrapper').css('bottom', $('.sitewide-hours.desktop').height() + 'px')

      menuRevealTimeline
        .add({
          targets: ".splash-content p, .splash-content h3, .hero-bottom-area a",
          opacity: 0,
          scale: 0.85,
        })
        .add(
          {
            targets: ".splash-content",
            top: "0",
            translateX: ['-50%', '-50%'],
            translateY: ['-50%', '-20%']
          },
          "-=500"
        )
        .add(
          {
            targets: ".splash-content figure",
            width: 250,
          },
          0
        )
        .add(
          {
            targets: ".main-content-wrapper",
            opacity: 1,
          },
          "-=500"
        )
        .add(
          {
            targets: ".menu-blocks .gold-background",
            bottom: 1,
          },
          "-=500"
        )
        .add(
          {
            targets: ".menu-blocks .menu-block > *",
            scale: [0.8, 1],
            opacity: 1,
          },
          "-=500"
        )
        .add(
          {
            targets: ".main-content-wrapper .sitewide-hours",
            opacity: 1,
          },
          "-=500"
        );
      } else {
        $('body').removeClass('main-menu-open')
        if ($(window).width() > 767) {
          var menuCloseTimeline = anime.timeline({
            easing: "cubicBezier(0.7, 0, 0.2, 1)",
            // duration: 1,
            duration: 1000,
            complete: function () {
              $(".main-content-wrapper").addClass("hide");
            },
          });

          menuCloseTimeline
            .add({
              targets: ".main-content-wrapper .sitewide-hours",
              opacity: 0,
            })
            .add(
              {
                targets: ".menu-blocks .menu-block > *",
                scale: [1, 0.8],
                opacity: 0,
              },
              "-=1000"
            )
            .add(
              {
                targets: ".menu-blocks .gold-background",
                bottom: [1, "100%"],
              },
              "-=500"
            )
            .add(
              {
                targets: ".main-content-wrapper",
                opacity: 0,
              },
              "-=500"
            )
            .add(
              {
                targets: ".splash-content",
                top: "40%",
                translateX: ['-50%', '-50%'],
                translateY: ['-20%', '-50%']
              },
              "-=700"
            )
            .add(
              {
                targets: ".splash-content figure",
                width: 400,
              },
              "-=1000"
            )
            .add(
              {
                targets:
                  ".splash-content p, .splash-content h3, .hero-bottom-area a",
                opacity: 1,
                scale: 1,
              },
              "-=500"
            );
        } else {
          var menuCloseTimeline = anime.timeline({
            easing: "cubicBezier(0.7, 0, 0.2, 1)",
            // duration: 1,
            duration: 1000,
            complete: function () {
              $(".main-content-wrapper").addClass("hide");
            },
          });

          menuCloseTimeline
            .add({
              targets: ".main-content-wrapper .sitewide-hours",
              opacity: 0,
            })
            .add(
              {
                targets: ".menu-blocks .menu-block > *",
                scale: [1, 0.8],
                opacity: 0,
              },
              "-=1000"
            )
            .add(
              {
                targets: ".menu-blocks .gold-background",
                bottom: [1, "100%"],
              },
              "-=500"
            )
            .add(
              {
                targets: ".main-content-wrapper",
                opacity: 0,
              },
              "-=500"
            )
            .add(
              {
                targets: ".splash-content",
                top: "40%",
                translateX: ['-50%', '-50%'],
                translateY: ['-20%', '-50%']
              },
              "-=700"
            )
            .add(
              {
                targets: ".splash-content figure",
                width: 300,
              },
              "-=1000"
            )
            .add(
              {
                targets:
                  ".splash-content p, .splash-content h3, .hero-bottom-area a",
                opacity: 1,
                scale: 1,
              },
              "-=500"
            );
        }
      }
  }

  function closeMenu() {
    
  }

  function introAnimation() {
    var loadingTimeline = anime.timeline({
      easing: "cubicBezier(0.7, 0, 0.2, 1)",
      duration: 750,
      complete: function (anim) {
        $(".loader").css("z-index", -1);
        $(".loader-image").css("z-index", -1);
        $(".loader-curtains").css("z-index", -1);
      },
    });

    loadingTimeline
      .add(
        {
          targets: ".loader-image",
          opacity: [1, 0],
        },
        0
      )
      .add(
        {
          targets: ".loader-curtains",
          opacity: [1, 0],
        },
        0
      )
      .add(
        {
          targets:
            "nav.navbar .center-logo img, .landing-page-content .landing-logo img, .splash-content-wrapper .splash-content figure img",
          scale: [0.85, 1],
          opacity: 1,
          duration: 1500,
        },
        "-=200"
      )
      .add(
        {
          targets:
            ".splash-content-wrapper .splash-content span, .splash-content-wrapper .splash-content a, .splash-content-wrapper .splash-content p, .splash-content-wrapper .splash-content img, .hero-bottom-area a",
          opacity: 1,
        },
        "-=520"
      );
    // .add({
    // 	targets: 'header .navbar-logo',
    // 		scale: [0.85, 1],
    // 		opacity: 1
    // }, '-=600')
  }

  function unloadAnimation(link) {
    var unloadingTimeline = anime.timeline({
      easing: "cubicBezier(0.7, 0, 0.2, 1)",
      duration: 750,
      update: function (anim) {
        $(".loader").css("z-index", 1000);
        $(".loader-image").css("z-index", 1000);
        $(".loader-curtains").css("z-index", 1000);
      },
      complete: function () {
        window.location.href = link;
      },
    });

    unloadingTimeline
      .add(
        {
          targets: ".loader-image",
          opacity: [0, 1],
        },
        750
      )
      .add(
        {
          targets: ".loader-curtains",
          opacity: [0, 1],
        },
        750
      );
  }

  function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
        return "Windows Phone";
    }

    if (/android/i.test(userAgent)) {
        return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
    }

    return "unknown";
  }

  function tripleseat_form_customizations() {
    $("#tripleseat_embed_form .row_email_address").append($("#tripleseat_embed_form .row_phone_number td").first());
    // $("#tripleseat_embed_form .row_event_description").append($("#tripleseat_embed_form .row_event_date td"));

    $("#tripleseat_embed_form .row_email_address td").attr("colspan", "");
    // $("#tripleseat_embed_form .row_event_description td").attr("colspan", "");
    $("#tripleseat_embed_form .row_event_date td").attr("colspan", "");
    // $("#tripleseat_embed_form .row_event_description td:first-child label").text("Type of Event");
    
    $("#tripleseat_embed_form .row_guest_count td").attr("colspan", "");
    $("#tripleseat_embed_form .row_event_date").append($("#tripleseat_embed_form .row_guest_count td").first())

    $('#tripleseat_embed_form input[type="submit"]').val("Send Now");

    $(".row_contact_preference").hide();
    $(".row_company").hide();
    $(".row_contact_header").hide();
    $(".row_details_header").hide();
    $(".row_event_style").hide();
    $(".row_referred_by").hide();
    $(".row_time").hide();
    $(".row_submit a").hide();
  }

  introAnimation();

  $.cookie("community-embed-4bc2e842-ad7f-46a7-b3ab-a1fd6cef06a7", "", {path: "/",});

  $(window).unload(function (e) {
    e.stopImmediatePropagation();
  });

  $(".custom-month-year span").on("click", function () {
    
    $(".custom-month-year span").removeClass("active");
    $(this).addClass("active");
  });

  $(".arrow-down").on("click", function () {
    $([document.documentElement, document.body]).animate(
      {
        scrollTop: $(".main-content-wrapper").offset().top,
      },
      250
    );
  });

  if ($(window).width() < 768) {
    /* $('.site-main').css('padding-bottom', 119)
		if (iOSSafari) {
			$('.site-main').css('padding-bottom', 100)
		} */

    $(".modal-promotion .btn").hover(function (e) {
      let modalPromotionButton = $(this).data("target");
      $(".modal-promotion").modal("hide");
      $(modalPromotionButton).modal();
    });
  }

  if (
    $("body").hasClass("home") &&
    (typeof $.cookie("firstLoad") == "undefined" ||
      $.cookie("firstLoad") == null)
  ) {
    $(".loader-image").removeClass("hide");
  }

  $(document).on("ready", function () {
    $("html").scrollTop(0);
    tripleseat_form_customizations();

    if (
      $(".enable-popup").length ||
      ($("body").hasClass("home") &&
        (typeof $.cookie("firstLoad") == "undefined" ||
          $.cookie("firstLoad") == null))
    ) {
      $.cookie("firstLoad", "newVisitor", { path: "/" });
      $("body").addClass("transparent-backdrop");
      setTimeout(function () {
        $("#modal-promotion").modal();
      }, 1550);
    }
  });

  $(window).on("load", function () {
    $("html").scrollTop(0);
    sleep(800).then(() => {
      $("body").addClass("done-loading");
    });

    // setTimeout(function () {
    //   console.log($('iframe[title="Community').contents().find('body').html())
    //   $('iframe[title="Community').contents().find('body').clone().html().appendTo('#communityModalClone');
    // }, 6000);

    $("#OT_partySizeLbl").html("PARTY DETAILS");

    jQuery('a[href="#modal-spotify"]').click(function () {
      jQuery("#modal-spotify").modal();
    });

    jQuery('a[href="#modal-spotify-artist"]').click(function (e) {
      jQuery("#modal-spotify-artist").modal();
    });

    $('a[href="#menuGrid"]').on("click", function () {
      $(".main-content-wrapper").removeClass("hide");
      toggleMainMenu();
    });

    /* $('a[href^="/event/"]').on("click", function (e) {
      //e.preventDefault();
      openEventPage($(this).attr("href"));
    }); */

  });

  $("#navbarNavDropdown").on("show.bs.collapse", function (e) {
    $("body").addClass("scroll-lock");
    $(".navbar-toggle").addClass("open");
    $(".navbar-nav").addClass("show");
    var mobileMenuTimeline = anime.timeline({
      easing: "cubicBezier(0.7, 0, 0.2, 1)",
      duration: 750,
      begin: function (anim) {
        setTimeout(function () {
          $("#navbarNavDropdown").addClass("animated");
        }, 500);
      },
    });

    mobileMenuTimeline.add({
      targets: "#navbarNavDropdown",
      top: "0",
    });
  });

  $("#navbarNavDropdown").on("hide.bs.collapse", function (e) {
    $("body").removeClass("scroll-lock");
    $("#navbarNavDropdown").removeClass("animated");
    var mobileMenuTimeline = anime.timeline({
      easing: "cubicBezier(0.7, 0, 0.2, 1)",
      duration: 750,
      begin: function (anim) {
        $("#navbarNavDropdown").removeClass("animated");
      },
      complete: function (anim) {
        $(".navbar-toggle").removeClass("open");
        $(".navbar-nav").removeClass("show");
      },
    });

    mobileMenuTimeline.add(
      {
        targets: "#navbarNavDropdown",
        top: "-100vh",
      },
      750
    );
  });

  $("nav.navbar ul.navbar-nav li.menu-item:not(.dropdown) a.nav-link").on(
    "click",
    function () {
      $("#navbarNavDropdown").collapse("hide");
    }
  );

  function goToPageByHash(hash) {
    
    console.log('goToPageByHash: ' + hash);
    // back to home
    if (hash == "") {
      // hide spotify modal
      jQuery("#modal-spotify").modal("hide");
      // hide menu grid if visible
      if (!jQuery(".main-content-wrapper").hasClass("hide")) {
        $(".splash-content figure")[0].click();
      }
    }

    // back to menu grid
    else if (hash == "#menuGrid") {
      // hide spotify modal
      jQuery("#modal-spotify").modal("hide");
      // hide eventsModal
      jQuery("#eventsModal").modal("hide");
      // hide faqsModal
      jQuery("#faqsModal").modal("hide");
      // show menu grid if not visible
      if (jQuery(".main-content-wrapper").hasClass("hide")) {
        $('a[href="#menuGrid"]')[0].click();
      }
    }

    // back to faqs
    else if (hash == "#faqsModal") {
      $('a[href="#faqsModal"]')[0].click();      
    }

    // back to events calendar
    else if (hash == "#eventsModal") {
      // hide single event modal
      $(".event-page-controls span.close-page")[0].click();
      // open events calendar
      $('a[href="#eventsModal"]')[0].click();
    }

    // back to single event modal
    else if (hash.includes("#event/")) {
      jQuery("#modal-spotify-artist").modal("hide");
      openEventPage(hash);
    }

    // back to spotify modal
    else if (hash == "#modal-spotify") {
      jQuery("#modal-spotify").modal();
    }

    // back to artist spotify modal
    else if (hash == "#modal-spotify-artist") {
      jQuery("#modal-spotify-artist").modal();
    }
  }

  $(document).ready(function () {

    var allPanels = $('.accordion > .item > .answer').hide();

    $("#eventPage .event-image img").on('touchstart', function (event) {
      const xClick = event.originalEvent.touches[0].pageX;
      $(this).one('touchmove', function (event) {
        const xMove = event.originalEvent.touches[0].pageX;
        const sensitivityInPx = 5;

        if (Math.floor(xClick - xMove) > sensitivityInPx) {
          var eventNext = jQuery(".event-next");
          if (!eventNext.hasClass('disabled')) {
            document.getElementsByClassName('event-next')[0].click()
          }
        }
        else if (Math.floor(xClick - xMove) < -sensitivityInPx) {
          var eventPrev = jQuery(".event-prev");
          if (!eventPrev.hasClass('disabled')) {
            document.getElementsByClassName('event-prev')[0].click()
          }
        }
      });
    });
    
    $('.accordion > .item > .question > a').click(function() {
      var closing = $(this).parent().next().is(":visible");
      allPanels.slideUp();
      if (!closing) $(this).parent().next().slideDown();
      return false;
    });

    window.addEventListener(
      "popstate",
      function (event) {
        if (!internalClick) goToPageByHash(window.location.hash);
        internalClick = false;
      },
      false
    );
    
    $('a[href="#menu-item-custom-events"]').attr("data-toggle", "modal");
    $('a[href="#menu-item-custom-events"]').attr("data-target","#privateDiningModal");
    
    $('a[href="#boothModal"]').attr("data-toggle", "modal");
    $('a[href="#boothModal"]').attr("data-target","#boothModal");

    $('a[href="#openTableModal"]').attr("data-toggle", "modal");
    $('a[href="#openTableModal"]').attr("data-target", "#openTableModal");

    //$('a[href="#eventsModal"]').attr("data-toggle", "modal");
    //$('a[href="#eventsModal"]').attr("data-target", "#eventsModal");
    $('a[href="#eventsModal"]').click(function () {
      jQuery("#eventsModal").modal();
    });

    $('a[href="#faqsModal"]').click(function () {
      jQuery("#faqsModal").modal();
    });

    var howardsEvents = {};

    $(".event-item").each(function (event) {
      var eventDate =
        $(this).find(".event-date").text() != ""
          ? $(this).find(".event-date").text()
          : "01-01-1900";
      var eventTitle = $(this).find(".event-title").html();      
      if (typeof howardsEvents[eventDate] != 'undefined')
        howardsEvents[eventDate] += eventTitle
      else
        howardsEvents[eventDate] = eventTitle;  
    });

    // var howardsEvents = {
    //   '10-21-2022' : '<a href="http://www.wincalendar.com/Great-American-Smokeout">Great American Smokeout</a>',
    //   '11-13-2013' : '<span>Ashura [An example of an complete date event (11-13-2013)]</span>',
    //   '11-11-2013' : '<a href="http://www.wincalendar.com/Remembrance-Day">Remembrance Day (Canada)</a>',
    //   '11-04-2013' : '<span>Islamic New Year</span>',
    //   '11-03-2013' : '<a href="http://www.wincalendar.com/Daylight-Saving-Time-Ends">Daylight Saving Time Ends</a>',
    //   '11-01-2013' : '<span>All Saints Day</span>',
    //   '12-25-YYYY' : '<span>Christmas Day [Date : 12-25-YYYY]</span>',
    //   '01-01-YYYY' : '<span>New Year\'s Eve (Event repeats every YEAR)</span>',
    //   'MM-02-2013' : '<span>Yeah, Monthly [MM-02-2013]</span>',
    //   'MM-07-YYYY' : '<span>[MM-07-YYYY], Monthly and Yearly</span>',
    //   '11-DD-2014' : {content : '<span>Ex: {\'11-DD-2014\' : {content : \'Something\', endDate : 20}}</span>', endDate : 20},
    //   '02-DD-2014' : {content : '<span>Ex: {\'02-DD-2014\' : {content : \'Something\', startDate : 10, endDate : 20}}</span>', startDate : 10, endDate : 20},
    //   '12-DD-YYYY' : '<span>[12-DD-YYYY] Whole month and Year</span>',
    //   'TODAY' : '<span>Today, [Date : \'TODAY\']</span>',
    //   '10-16-2014': ['<a href="">event one</a>', '<span>event two</span>'],
    //   '10-DD-YYYY' : [
    //     {content : '<span>Ex: {\'10-DD-2014\' : {content : \'Something\', startDate : 10, endDate : 20}}</span>', startDate : 10, endDate : 20},
    //     {content : '<span>Ex: {\'10-DD-2014\' : {content : \'Something\', endDate : 20}}</span>', endDate: 20},
    //   ]
    // }

    var cal = $("#calendar").calendario({
        onDayClick: function ($el, $contentEl, dateProperties) {
          for (var key in dateProperties) {
            //console.log(key + " = " + dateProperties[key]);
          }
        },
        caldata: howardsEvents,
      }),
      $month = $("#custom-month").html(cal.getMonthName()),
      $year = $("#custom-year").html(cal.getYear());

    $("#custom-next").on("click", function () {
      cal.gotoNextMonth(updateMonthYear);
    });
    $("#custom-prev").on("click", function () {
      cal.gotoPreviousMonth(updateMonthYear);
    });
    $("#custom-current").on("click", function () {
      cal.gotoNow(updateMonthYear);
    });

    function updateMonthYear() {
      $month.html(cal.getMonthName());
      $year.html(cal.getYear());
    }

    $(".fc-calendar-event a, .event-next, .event-prev").on("click", function (e) {
      openEventPage($(this).attr("href"));
    }); 

    $(".event-page-controls span.close-page").on("click", function () {
      anime({
        targets: "#eventPage",
        opacity: 0,
        top: "100vh",
        easing: "cubicBezier(0.7, 0, 0.2, 1)",
        duration: 1000,
      });
    });

    // internal website click control (for browser back button)
    $("a").on("click", function () {
      internalClick = true;
    });

  });

$(document).on('DOMMouseScroll', function (e) {
    var delta = e.originalEvent.detail;

    if (delta < 0) {
        //console.log('You scrolled up');
    } else if (delta > 0) {
        //console.log('You scrolled down');
    }

});

  $(window).scroll(function () {
    var $this = $(this);
    if ($this.scrollTop() > 250) {
      $(".back-to-top").addClass("scrolled");
      $(".back-to-top a").attr("href", "#top-header");
    } else {
      $(".back-to-top").removeClass("scrolled");
      $(".back-to-top a").attr("href", "#top-header");
    }

    var wHeight = $(window).width() > 767 ? $(window).height() + 300 : $(window).height()
    var scrollTop = $(window).width() > 767 ? $(window).scrollTop() + 800 : $(window).scrollTop() - 800

    if (scrollTop > -500) {
      anime({
        targets: ".menu-blocks:not(.animated) .gold-background",
        bottom: 1,
        duration: 750,
        easing: "cubicBezier(0.7, 0, 0.2, 1)",
      })

      anime({
        targets: ".menu-blocks:not(.animated) .menu-block > *",
        scale: [0.8, 1],
        opacity: 1,
        duration: 750,
        delay: 750,
        easing: "cubicBezier(0.7, 0, 0.2, 1)",
        complete: function(){
          $('.menu-blocks').addClass('animated')
        }
      })
    }
  });

  $(window).resize(function () {
    vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  });

  if ($(window).width() < 768) {
    if (window.orientation !== 0) {
      $(".orientation-alert").addClass("in");
      $("body").addClass("scroll-lock");
      // $('body').css('background-color', '#CE433A');
    } else {
      $(".orientation-alert").removeClass("in");
      $("body").removeClass("scroll-lock");
      // $('body').css('background-color', '#fff');
    }

    // $('.main-content-wrapper').removeClass('hide')
    $('.splash-content-wrapper').css('height', window.innerHeight)
  }

  if ($(window).width() < 768) {
    $(window).on("orientationchange", function (event) {
      if (window.orientation !== 0) {
        // unleashPacmanMobile();
        setTimeout(function () {
          $(".orientation-alert").addClass("in");
          $("body").addClass("scroll-lock");
        }, 0);
      } else {
        // leashPacman();
        $(".orientation-alert").removeClass("in");
        $("body").removeClass("scroll-lock");
      }
    });
  }  
})(window.Zept || window.jQuery, window, document);